<template>
<Header/>
    <Banner  name="Course Details" :message="this.$route.params.slug"  />
    <!-- Courses Start -->
        <div class="section section-padding mt-n10">
            <div class="container">
                <div class="row gx-10">
                    <div class="col-lg-8">
                        <!-- Courses Details Start -->
                        <div class="courses-details">
                            <div class="courses-details-images">
                                <img :src="getCourse.image" alt="Courses Details">
                                <span class="tags">{{ getCourse.category }}</span>
                                <!-- <div class="courses-play">
                                    <img src="@/assets/images/courses/circle-shape.png" alt="Play">
                                    <a class="play video-popup" href="https://www.youtube.com/watch?v=Wif4ZkwC0AM"><i class="flaticon-play"></i></a>
                                </div> -->
                            </div>

                            <h2 class="title">{{ getCourse.name }}</h2>

                            <div class="courses-details-admin">
                                <div class="admin-author">
                                    <div class="author-thumb">
                                        <img :src="getCourse.authorImage" alt="Author">
                                    </div>
                                    <div class="author-content">
                                        <a class="name" href="#">{{ getCourse.authorName }}</a>
                                        <span class="Enroll">35 Enrolled Students</span>
                                    </div>
                                </div>
                                <div class="admin-rating">
                                    <span class="rating-count">{{ getCourse.rating }}</span>
                                    <span class="rating-star">
											<span class="rating-bar" ref="ratingStar" style="width: 80%;"></span>
                                    </span>
                                    <span class="rating-text">({{ getCourse.countRating }} Rating)</span>
                                </div>
                            </div>

                            <!-- Courses Details Tab Start -->
                            <div class="courses-details-tab">

                                <!-- Details Tab Menu Start -->
                                <div class="details-tab-menu">
                                    <ul class="nav justify-content-center">
                                        <li><button class="active" data-bs-toggle="tab" data-bs-target="#description">Description</button></li>
                                        <li><button data-bs-toggle="tab" data-bs-target="#instructors">Instructors</button></li>
                                        <li><button data-bs-toggle="tab" data-bs-target="#reviews">Reviews</button></li>
                                    </ul>
                                </div>
                                <!-- Details Tab Menu End -->

                                <!-- Details Tab Content Start -->
                                <div class="details-tab-content">
                                    <div class="tab-content">
                                        <div class="tab-pane fade show active" id="description">

                                            <!-- Tab Description Start -->
                                            <div class="tab-description">
                                                <div class="description-wrapper">
                                                    <h3 class="tab-title">Description:</h3>
                                                    <p>{{ getCourse.description }}</p>
                                                </div>
                                                <div class="description-wrapper">
                                                    <h3 class="tab-title">Curriculum:</h3>
                                                    <!-- <p>{{ getCourse.Curriculum }}</p> -->
                                                </div>
                                            </div>
                                            <!-- Tab Description End -->

                                        </div>
                                        <div class="tab-pane fade" id="instructors">

                                            <!-- Tab Instructors Start -->
                                            <div class="tab-instructors">
                                                <h3 class="tab-title">Course Instructor:</h3>

                                                <div class="row">
                                                    <div class="col-md-3 col-6">
                                                        <!-- Single Team Start -->
                                                        <div class="single-team">
                                                            <div class="team-thumb">
                                                                <img :src="getCourse.authorImage" alt="Author">
                                                            </div>
                                                            <div class="team-content">
                                                                <div class="rating">
                                                                    <span class="count">4.9</span>
                                                                    <i class="icofont-star"></i>
                                                                    <span class="text">(rating)</span>
                                                                </div>
                                                                <h4 class="name">{{ getCourse.authorName }}</h4>
                                                                <span class="designation">{{ getCourse.authorQualification }}, Instructor</span>
                                                            </div>
                                                        </div>
                                                        <!-- Single Team End -->
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <!-- Tab Instructors End -->

                                        </div>
                                        <div class="tab-pane fade" id="reviews">

                                            
                                            <Review :reviews="Reviews"/>

                                        </div>
                                    </div>
                                </div>
                                <!-- Details Tab Content End -->

                            </div>
                            <!-- Courses Details Tab End -->

                        </div>
                        <!-- Courses Details End -->

                    </div>
                    <Sidebar :getCourse="getCourse" />
                </div>
            </div>
        </div>
        <!-- Courses End -->
        <CTA/>
<Footer/>
</template>
<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import Banner from '@/components/Banner.vue';
import Sidebar from '@/components/CourseDetails/CourseSideBar.vue';
import Review from '@/components/CourseDetails/Review.vue';
import CTA from '@/components/CTA.vue';
export default{
    name:'CourseDetails',
    components:{
        Header,Footer,Banner,Sidebar,CTA,Review
    },
    props:['course','slug'],
    computed:{
        getCourse(){
           return JSON.parse(this.course);
        }
    },
    data(){
        return{
            Reviews:[
                {name:"Peter Andrew",certificate:"DevOps",story:"Lorem Ipsum has been the industry's standard dummy text since the 1500 when unknown printer took a galley of type and scrambled to make type specimen book has survived not five centuries but also the leap into electronic type and book.",rating:4.5,image:"https://images.pexels.com/photos/7907687/pexels-photo-7907687.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"},
                {name:"Peter Andrew",certificate:"DevOps",story:"Lorem Ipsum has been the industry's standard dummy text since the 1500 when unknown printer took a galley of type and scrambled to make type specimen book has survived not five centuries but also the leap into electronic type and book.",rating:4.5,image:"https://images.pexels.com/photos/7907687/pexels-photo-7907687.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"},
                {name:"Peter Andrew",certificate:"DevOps",story:"Lorem Ipsum has been the industry's standard dummy text since the 1500 when unknown printer took a galley of type and scrambled to make type specimen book has survived not five centuries but also the leap into electronic type and book.",rating:4.5,image:"https://images.pexels.com/photos/7907687/pexels-photo-7907687.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"},
                {name:"Peter Andrew",certificate:"DevOps",story:"Lorem Ipsum has been the industry's standard dummy text since the 1500 when unknown printer took a galley of type and scrambled to make type specimen book has survived not five centuries but also the leap into electronic type and book.",rating:4.5,image:"https://images.pexels.com/photos/7907687/pexels-photo-7907687.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260"},
            ]
        }
    }
}
</script>